import { DOCUMENT } from '@angular/common';
import { Component, ElementRef, Inject, OnInit, Renderer2, ViewChild} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { take, tap } from 'rxjs/operators';
import { ReportsApiService } from 'src/app/api/reports-api.service';
import Swal from 'sweetalert2'
import XLSX from 'xlsx'

@Component({
  selector: 'app-reporte-consolidado',
  templateUrl: './reporte-consolidado.component.html',
  styleUrls: ['./reporte-consolidado.component.css']
})
export class ReporteConsolidadoComponent implements OnInit {

  @ViewChild('inicial',{static:false}) inicial:ElementRef
  @ViewChild('final',{static:false}) final:ElementRef
  @ViewChild('table',{static:false}) table:ElementRef
  filterSearch:string = ""

  data:Array<any[]>

  constructor(
   @Inject(DOCUMENT) private document:Document,
   private reportApiService: ReportsApiService,
   private render:Renderer2,
   private translate:TranslateService
  ) { }
  loading:boolean = false

  p:number=1

  ngOnInit() {
   
  }

  search(){
    const inicial = this.inicial.nativeElement.value + '-01'
    const final = this.final.nativeElement.value + '-01' 

    if(this.inicial.nativeElement.value === "" &&  this.final.nativeElement.value === ""){
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text:this.translate.instant('los campos fechas son requeridos')
        })
       return
    }

     this.loading = true
     this.reportApiService.getTotalConsolidado(inicial, final).pipe(
       take(1),
       tap(
         (res:any)=>{
           this.render.addClass(this.table.nativeElement, 'show')
           this.render.removeClass(this.table.nativeElement,'hide')
           this.data = res
           this.loading = false
           
         }
       )
     ).subscribe()
  }

  limpiar(){
      this.inicial.nativeElement.value = ""
      this.final.nativeElement.value = ""
      this.render.removeClass(this.table.nativeElement, 'show')
      this.render.addClass(this.table.nativeElement, 'hide')
  }

  export(){
     const result = this.data.map((item:any)=>{
         const datos= item
         delete datos.cod_pcrc
         delete datos.id_dp_pcrc
         return  { ...datos }
     })

     const ws:XLSX.WorkSheet = XLSX.utils.json_to_sheet(result)
     const wb:XLSX.WorkBook  = XLSX.utils.book_new()

     XLSX.utils.book_append_sheet(wb,ws,'sheet1')
     XLSX.writeFile(wb, 'consolidado.xlsx')
   }
  

}
